import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ClassList from 'class-list';
import PropTypes from 'prop-types';
import { FaInstagram, FaFacebookF } from "react-icons/fa";

import AdministrativeNavigation from '../containers/AdministrativeNavigation';

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.administrativeRoutes = [
      { label: 'Giochi', url: '/admin/boardgames' },
      { label: 'Categorie', url: '/admin/categories' },
      { label: 'Boardgame Night', url: '/admin/night' },
      { label: 'Replay', url: '/admin/replay' },
      { label: 'Eventi', url: '/admin/events' },
    ];
  }

  componentDidMount() {
    const clBody = ClassList(document.getElementById('wrapper'));

    clBody.add('navigation-open');
  }

  componentWillUnmount() {
    const clBody = ClassList(document.getElementById('wrapper'));
    
    clBody.remove('navigation-open');
  }

  render() {
    return (
      <nav className="fixed inset-0 z-40 w-screen h-screen-real bg-white touch overflow-y-auto">
        <div className="py-20 w-screen min-h-screen-real flex flex-col justify-center items-center">
          <ul className="text-center mb-10">
            <li className="flex items-center justify-center">
              <Link className="block font-serif font-black text-3xl hover:text-gray-600" to="/replay">
                <span>Replay</span>
              </Link>
              <span className="text-xs font-bold font-sans bg-orange-500 ml-2 py-1 px-3 rounded-full text-white uppercase">Nuovo</span>
            </li>
            <li className="mt-4">
              <a rel="noopener noreferrer" target="_blank" href="https://smart-gaming.it" className="block font-serif font-black text-3xl hover:text-gray-600">
                Blog
              </a>
            </li>
            <li className="mt-4">
              <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/pg/smartgamingit/events" className="block font-serif font-black text-3xl hover:text-gray-600">
                I prossimi eventi
              </a>
            </li>
            <AdministrativeNavigation routes={this.administrativeRoutes} />
          </ul>
          <ul className="mb-8">
            <li className="flex justify-center flex-col md:flex-row">
              
              <a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/smartgamingit" className="mb-4 md:mb-0 md:mr-8 block hover:opacity-75 rounded-full bg-facebook text-white flex items-center justify-center px-8 py-2 w-full md:w-auto">
                <FaFacebookF size="1.2em" className="mr-2" /><span className="font-medium">Like us on Facebook</span>
              </a>

              <a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/smartgamingit/" className="block hover:opacity-75 rounded-full bg-instagram-gradient text-white flex items-center justify-center px-8 py-2 w-full md:w-auto">
                <FaInstagram size="1.2em" className="mr-2" /><span className="font-medium">Follow us on Instagram</span>
              </a>
            </li>
          </ul>

          <ul>
            <li className="mt-4">
              {
                !this.props.isAuthenticated
                  ? <Link className="appearance-none w-full md:w-auto focus:outline-none focus:shadow border border-gray-600 bg-gray-600 text-white hover:bg-white hover:text-gray-600 flex justify-center items-center rounded-full px-12 py-2 mt-3 md:mt-0" to="/admin/login">
                      <span>Login</span>
                    </Link>
                  : <button onClick={this.props.onLogout}
                      className="appearance-none w-full md:w-auto focus:outline-none focus:shadow border border-gray-600 bg-gray-600 text-white hover:bg-white hover:text-gray-600 flex justify-center items-center rounded-full px-12 py-2 mt-3 md:mt-0"
                      type="button">
                        <span>Logout</span>
                    </button>
              }
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

Navigation.propTypes = {
  isAuthenticated: PropTypes.bool,
  isAdministrator: PropTypes.bool,
  onLogout: PropTypes.func,
};

Navigation.defaultProps = {
  isAuthenticated: false,
  isAdministrator: false,
};

export default Navigation;
